import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["checkbox", "checkboxAll", "irrelevantCheckbox"];

  connect() {
    this.changeSelectAllCheckbox();
  }

  // checks if all checkboxes (except irrelevant) are selected, and turns checkbox on/off accordingly
  changeSelectAllCheckbox() {
    const allCheckboxesSelected = this.checkboxTargets.every(
      (target) => target.checked
    );
    allCheckboxesSelected
      ? (this.checkboxAllTarget.checked = true)
      : (this.checkboxAllTarget.checked = false);
  }

  toggleAll(event) {
    if (this.hasIrrelevantCheckboxTarget) {
      if (event.target.checked) {
        this.checkboxTargets.forEach((checkbox) => {
          checkbox.checked = true;
        });
        this.irrelevantCheckboxTarget.checked = false;
      } else {
        this.checkboxTargets.forEach((checkbox) => {
          checkbox.checked = false;
        });
        this.irrelevantCheckboxTarget.checked = true;
      }
    } else {
      this.checkboxTargets.forEach((checkbox) => {
        checkbox.checked = event.target.checked;
      });
    }
  }

  checkboxChanged(event) {
    if (this.hasIrrelevantCheckboxTarget && event.target.checked) {
      this.irrelevantCheckboxTarget.checked = false;
    }
    this.changeSelectAllCheckbox();
  }

  irrelevantChanged(event) {
    if (event.target.checked) {
      this.checkboxTargets.forEach((checkbox) => {
        checkbox.checked = false;
      });
    }
    this.changeSelectAllCheckbox();
  }
}
